import { render } from "./myProfile.vue?vue&type=template&id=ca4da318"
import script from "./myProfile.vue?vue&type=script&lang=js"
export * from "./myProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__